import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useProfileDashboard = () => {

  const { api, userID } = useContext(GlobalContext);

// ORGANIZATION DETAILS
const fetchOrganizationDetails = async (forceRefresh = false) => {
  try {
   if (!userID || !api) {
  return null;
}

    const cacheKey = `organization_details_${userID}`;

    if (!forceRefresh) {
      const cachedData = sessionStorage.getItem(cacheKey);

      if (cachedData) {
        try {
          return JSON.parse(cachedData);
        } catch (error) {
          console.error("Organization cache parse error:", error);
          sessionStorage.removeItem(cacheKey);
        }
      }
    }

  const res = await api.post(
  "/User/getOrganizationDetails",
  {
    userid: userID,
  }
);

    const data = res.data;

    if (data?.responseCode === "00") {
      sessionStorage.setItem(
        cacheKey,
        JSON.stringify(data),
      );
    }

    return data;
  } catch (error) {
    console.error(
      "Organization details fetch error:",
      error,
    );

    return null;
  }
};

  const updateOrganizationInfo = async (payload) => {
  try {
   const res = await api.post(
  "/User/editOrganizationInfo",
  payload
);

    const data = res.data;

    if (data?.responseCode === "00") {
      const cacheKey = `organization_details_${userID}`;

      sessionStorage.removeItem(cacheKey);
      await fetchOrganizationDetails(true);
    }

    return data;
  } catch (error) {
    console.error(
      "Organization update error:",
      error,
    );

    throw error;
  }
};

  // INVOICE HISTORY
  const fetchInvoices = async (userid) => {
   const res = await api.post(
  "/Entitlement/getAllUserSubscriptions",
  { userid: userID }
);
    return res.data;
  };

  // WHATSAPP CREDENTIALS
  const getWhatsappCredentials = async (userid) => {
   const res = await api.post(
  "/Whatsapp/getWhatsappCredentials",
  { userid: userID }
);
    return res.data;
    
  };

  // CANCEL SUBSCRIPTION
  const cancelSubscription = async (payload) => {
 const res = await api.post(
  "/Entitlement/cancelSubscriptionPlan",
  payload
);
    return res.data;
  };

const fetchReceiptDetails = async () => {
  try {
   const res = await api.post(
  "/Order/getReceiptData",
  { userid: userID }
);

    if (res.data?.responseCode === "00") {
      return res.data;
    }

    return null;
  } catch (err) {
    console.error("Receipt details fetch error:", err);
    return null;
  }
};

  // UPDATE RECEIPT DATA
  const updateReceiptInfo = async (payload) => {
    const res = await api.post(
  "/Order/editReceiptData",
  payload
);
    return res.data;
  };

  // GET BANK LIST
  const getBankAccounts = async (userid) => {
   const res = await api.post(
  "/Transactions/getSettlementAccountList",
  { userid: userID }
);
    return res.data;
  };

  // ADD BANK
  const addBankAccount = async (payload) => {
   const res = await api.post(
  "/Transactions/addSettlementAccount",
  payload
);
    return res.data;
  };

  // FETCH ALA CARTE
  const fetchAlaCartePlans = async (payload) => {
   const res = await api.post(
  "/Entitlement/fetchAlaCarte",
  payload
);
    return res.data;
  };

  // BUY SUBSCRIPTION PLAN
  const buySubscriptionPlan = async (payload) => {
   const res = await api.post(
  "/Entitlement/buySubscriptionPlan",
  payload
);
    return res.data;
  };

  // UPGRADE SUBSCRIPTION PLAN
  const upgradeSubscriptionPlan = async (payload) => {
  const res = await api.post(
  "/Entitlement/upgradeSubscriptionPlan",
  payload
);
    return res.data;
  };

  // BUY ADDONS
  const buyAddOns = async (payload) => {
   const res = await api.post(
  "/Entitlement/buyAddOns",
  payload
);
    return res.data;
  };

  // ADD WHATSAPP CREDENTIALS
const addWhatsappCredentials = async (payload) => {
const res = await api.post(
  "/Whatsapp/addWhatsappCredentials",
  payload
);
  return res.data;
};

// GET DASHBOARD DATA
const getDashboardData = async (payload) => {
const res = await api.post(
  "/Whatsapp/getDashboardData",
  payload
);
  return res.data;
};

  return {
    fetchOrganizationDetails,
    updateOrganizationInfo,
    fetchInvoices,
    getWhatsappCredentials,
    cancelSubscription,
    fetchReceiptDetails,
    updateReceiptInfo,
    getBankAccounts,
    addBankAccount,
    fetchAlaCartePlans,
    buySubscriptionPlan,
    upgradeSubscriptionPlan,
    buyAddOns,
    addWhatsappCredentials,
    getDashboardData,
  };
};

export default useProfileDashboard;
